import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import RadioField from '../app-main/components/reduxForms/fields/RadioField/RadioField';
import ToggleSwitchField from '../app-main/components/reduxForms/fields/ToggleSwitchField/ToggleSwitchField';
import { onToggleSwitch, onToggleSetHours, onAddHours } from './forms/onChangeOpHoursForm';
import SelectTimeFieldHOC from '../app-main/components/reduxForms/fields/SelectTimeField/SelectTimeFieldHOC';
import { ConvertTimeToIndexHOC, normalizeTimeIndex } from '../app-main/components/reduxForms/fields/SelectTimeField/ConvertTimeIndex';
import SelectField from 'shared-components/reduxForms/fields/SelectField/SelectField';
import classnames from 'classnames';
import { TimeMap } from '../elements-date-time/data/time-data';
import { get, isBool, findLastKey } from 'lodash';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import moment from 'moment';

const OpHoursRow = ({
  formValue = {},
  fields,
  dowHash,
  enforceSocialEventOpHours = false,
  meta = {},
  intl
}) => {
  const SelectTimeField = ConvertTimeToIndexHOC(SelectTimeFieldHOC(intl, SelectField));
  const translationMessage = defineMessages({
    allDay: {
      id: 'hosting.op_hours_row.all_day',
      defaultMessage: 'All day (24 hrs)'
    },
    optionErrorMessage: {
      id: 'hosting.op_hours_row.option_error_message',
      defaultMessage: 'Please select an option'
    },
    timeErrorMessage: {
      id: 'hosting.op_hours_row.time_errror_message',
      defaultMessage: 'Please enter a valid time'
    },
    setHours: {
      id: 'hosting.op_hours_row.set_hours',
      defaultMessage: 'Set hours'
    },
    open: {
      id: 'hosting.op_hours_row.open',
      defaultMessage: 'Open'
    },
    closed: {
      id: 'hosting.op_hours_row.closed',
      defaultMessage: 'Closed'
    }
  });
  const isSocialEventPolicyAllDay = get(formValue, 'dows.0.is_social_event_policy_all_day');
  const isAllDay = get(formValue, 'dows.0.all_day') || isSocialEventPolicyAllDay;
  const isOpen = get(formValue, 'is_open');
  const dow = dowHash.value;

  const localizeTime = (time) => {
    return intl.formatTime(moment(time, 'HH:mm a').format());
  };

  return (
    <div>
      {
        fields.map((field, index) => {
          const allDayLabel = enforceSocialEventOpHours ? `${localizeTime('6:00 am')} - ${localizeTime('12:00 am')}` : intl.formatMessage(translationMessage.allDay);
          const startTimeIndex = get(formValue, `dows.${index}.start`, 0);
          const endTime = get(formValue, `dows.${index}.end.time`);
          const endTimeIndex = parseInt(findLastKey(TimeMap, endTime), 10);
          const showAddHoursBtn = !isAllDay &&
                                  isOpen &&
                                  (fields.length === index + 1) &&
                                  (35 > endTimeIndex);

          const containerClassName = classnames('OpHoursInnerRow flex middle', {
            'margin-lg-bottom': !(fields.length === index + 1),
            'show-add-hours-btn': showAddHoursBtn
          });

          const allDayFieldName = enforceSocialEventOpHours && isSocialEventPolicyAllDay ?
            `${field}.is_social_event_policy_all_day` :
            `${field}.all_day`;

          return (
            <div className={containerClassName} key={field}>
              {
                0 === index &&
                <div className="flex-basis-10-md flex-basis-50 heavy">
                  { dowHash.fullLabel}
                </div>
              }
              {
                0 === index &&
                <div className="switch-container flex-basis-50">
                  <Field
                    component={ToggleSwitchField}
                    name={`opHours.${dowHash.value}.is_open`}
                    errorMessage={intl.formatMessage(translationMessage.optionErrorMessage)}
                    onText={intl.formatMessage(translationMessage.open)}
                    offText={intl.formatMessage(translationMessage.closed)}
                    onChange={(e, value) => onToggleSwitch({ value, fields, dow })}
                  />
                </div>
              }
              {
                (isOpen && 0 === index) &&
                <div className="all-day-container flex-basis-100">
                  <Field
                    containerClassName="flex"
                    component={RadioField}
                    name={allDayFieldName}
                    className="margin-lg-right"
                    errorMessage={intl.formatMessage(translationMessage.optionErrorMessage)}
                    normalize={(value) => !isBool ? 'true' === value : value}
                    onChange={(e, value) => onToggleSetHours({ value, fields, dow })}
                    options={[
                      {
                        id: `all-day-${dowHash.value}-yes`,
                        value: true,
                        label: allDayLabel
                      },
                      {
                        id: `all-day-${dowHash.value}-no`,
                        value: false,
                        label: intl.formatMessage(translationMessage.setHours)
                      }
                    ]}
                  />
                </div>
              }
              { 0 < index && <div className="flex-basis-65" /> }
              {
                (!isAllDay && isOpen) &&
                <div className="flex-basis-35-md flex-basis-100">
                  <div key={`${field}-time`} className="flex baseline time-container">
                    <Field
                      className="flex-grow-1"
                      component={SelectTimeField}
                      name={`${field}.start`}
                      normalize={normalizeTimeIndex}
                      errorMessage={intl.formatMessage(translationMessage.timeErrorMessage)}
                      isStartTime
                    />
                    <div className="margin-md-left margin-md-right"><FormattedMessage id="hosting.op_hours_row.to" defaultMessage="to"/></div>
                    <Field
                      className="flex-grow-1"
                      component={SelectTimeField}
                      name={`${field}.end`}
                      normalize={normalizeTimeIndex}
                      errorMessage={intl.formatMessage(translationMessage.timeErrorMessage)}
                      startTimeIndex={startTimeIndex}
                      maxEndTime={enforceSocialEventOpHours ? 36 : null}
                      isEndTime
                    />
                    {
                      ((fields.length === index + 1) && 0 < index) &&
                      <button
                        type="button"
                        onClick={() => fields.remove(index) }
                        className="btn-link no-gutter remove-click-styling"
                      >
                        <i className="ico icon-no"></i>
                      </button>
                    }
                  </div>
                  {
                    showAddHoursBtn &&
                    <button
                      type="button"
                      onClick={() => onAddHours({ fields, index })}
                      className="add-hours-btn btn-link no-gutter remove-click-styling margin-md-top"
                    >
                      <FormattedMessage id="hosting.op_hours_row.button_text_add_hours" defaultMessage="Add hours"/>
                    </button>
                  }
                </div>
              }
            </div>
          );
        })
      }
      { meta.error && <div className="text-danger text-small margin-md-top">{meta.error}</div> }
    </div>
  );
};

OpHoursRow.propTypes = {
  dowHash: PropTypes.object,
  fields: PropTypes.object,
  formValue: PropTypes.object,
  meta: PropTypes.object,
  enforceSocialEventOpHours: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(OpHoursRow);
